import { useContext, useEffect, useState } from "react";
import { read, utils } from "xlsx";
import { config, createColumns } from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useImportB2BWorkData = () => {
  const { t } = useLocale();
  const { save, update } = useService("Data", "b2bDailyWorkData");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { getFormattedDate, generateUID, showAlert, isBottom } =
    useService("Misc");
  const { commonPageSize } = config;
  const [tableContent, settableContent] = useState(null);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [file, setfile] = useState(null);
  const [data, setdata] = useState([]);
  const [cols, setcols] = useState([]);
  const [excelWorkList, setexcelWorkList] = useState([]);
  const [fileImported, setfileImported] = useState<boolean>(false);
  const [fileSelected, setfileSelected] = useState<boolean>(false);
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [importWorkData, setimportWorkData] = useState([]);
  const [tableData, settableData] = useState([]);
  const [showTable, setshowTable] = useState<boolean>(false);
  const [importDone, setimportDone] = useState<boolean>(false);
  const [resultWorkList, setresultWorkList] = useState([]);
  const [filteredList, setfilteredList] = useState([]);

  setTitle("Import Daily B2b Work Data", "admin");

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const handleChange = (e) => {
    const files = e.target.files;
    if (files && files[0]) {
      setfile(files[0]);
      setfileSelected(true);
    }
  };

  const handleFile = () => {
    showPreloader();
    setshowTable(true);
    let excelWorkList = [],
      reader = new FileReader(),
      rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      let bstr = e.target.result,
        wb = read(bstr, {
          type: rABS ? "binary" : "array",
          bookVBA: true,
          cellDates: true,
        }),
        wsname = wb.SheetNames[0],
        ws = wb.Sheets[wsname],
        data = utils.sheet_to_json(ws, { raw: false, rawNumbers: true });
      setdata(data);
      setcols(createColumns(ws["!ref"]));
      data.forEach((e) => {
        if (e["Vehicle No (In Capital Letters)"] !== "") {
          e["Timestamp"] = String(getFormattedDate(new Date(e["Timestamp"])));
          e["Date"] = String(getFormattedDate(new Date(e["Date"])));
          e["Yard Name"] = String(e["Yard Name"]);
          e["ownerId"] = e["Yard Name"];
          e["registrationNo"] =
            e["Vehicle No (In Capital Letters)"].toUpperCase();
          excelWorkList.push(e);
        }
      });
      setexcelWorkList(excelWorkList);
      setfileImported(true);
      hidePreloader();
    };
    if (rABS) {
      //@ts-ignore
      reader.readAsBinaryString(file);
    } else {
      //@ts-ignore
      reader.readAsArrayBuffer(file);
    }
  };

  const processExcel = () => {
    setshowTable(false);
    let mode = "add",
      activeItem = null;
    excelWorkList.forEach((e, i) => {
      tableData.forEach((item) => {
        if (String(e.uid) === item.uid) {
          mode = "edit";
          activeItem = item;
        }
      });
      setTimeout(() => {
        addWork(e, mode, activeItem, i);
      }, i * 10);
    });
  };

  const addWork = async (item, mode, oldCar = null, i) => {
    let success = false;
    item.ownerId = String(item.ownerId);
    let b2bDailyWorkDataObject = item;
    try {
      if (mode === "add") {
        b2bDailyWorkDataObject.uid = generateUID();
        const result = await save(b2bDailyWorkDataObject);
        if (result.status) {
          success = true;
          setimportWorkData(result);
        } else {
          showAlert({ type: "error", msg: "Unable to add WorkData!" });
        }
      } else {
        let data = {
          query: JSON.stringify({ uid: String(oldCar.uid) }),
          b2bDailyWorkDataData: JSON.stringify(b2bDailyWorkDataObject),
        };
        const result = await update(data);
        if (result.status) {
          success = true;
          setimportWorkData(result);
        } else {
          showAlert({ type: "error", msg: "Unable to update WorkData!" });
        }
      }
      if (excelWorkList.length - 1 === i) {
        setshowTable(false);
        setimportDone(true);
      }
      resultWorkList.push({ ...item, ...{ success } });
      setresultWorkList(resultWorkList);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getTableData = (filterData) => {
    let data = [];
    try {
      filterData.forEach((item, i) => {
        let e = {
          "Sr. No.": i + 1,
          Timestamp: item["Timestamp"],
          Date: item["Date"],
          "Vehicle No (In Capital Letters)":
            item["Vehicle No (In Capital Letters)"].toUpperCase(),
          "Yard Name": item["Yard Name"],
          "Cleaning Work Done": item["Cleaning Work Done"],
          "Vehicle Inspection Done": item["Vehicle Inspection Done"],
          "Engine Starting": item["Engine Starting"],
          "Status [Switches Working]": item["Status [Switches Working]"],
          "Status [AC Working]": item["Status [AC Working]"],
          "Status [Lights Working]": item["Status [Lights Working]"],
          "Battery Voltage": item["Battery Voltage"],
          "Vehicle Tyre Status": item["Vehicle Tyre Status"],
          "Service Done [Puncture Repair]":
            item["Service Done [Puncture Repair]"],
          "Service Done [Battery Charging]":
            item["Service Done [Battery Charging]"],
          "Vehicle Running Condition": item["Vehicle Running Condition"],
        };
        data.push(e);
      });
    } catch (e) {
      console.log("error", e);
    }
    return data;
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: t("srNo"),
          key: "Sr. No.",
        },
        {
          label: "Timestamp",
          key: "Timestamp",
        },
        {
          label: "Date",
          key: "Date",
        },
        {
          label: "Vehicle No (In Capital Letters)",
          key: "Vehicle No (In Capital Letters)",
        },
        {
          label: "Yard Name",
          key: "Yard Name",
        },
        {
          label: "Cleaning Work Done",
          key: "Cleaning Work Done",
        },
        {
          label: "Vehicle Inspection Done",
          key: "Vehicle Inspection Done",
        },
        {
          label: "Engine Starting",
          key: "Engine Starting",
        },
        {
          label: "Status [Switches Working]",
          key: "Status [Switches Working]",
        },
        {
          label: "Status [AC Working]",
          key: "Status [AC Working]",
        },
        {
          label: "Status [Lights Working]",
          key: "Status [Lights Working]",
        },
        {
          label: "Battery Voltage",
          key: "Battery Voltage",
        },
        {
          label: "Vehicle Tyre Status",
          key: "Vehicle Tyre Status",
        },
        {
          label: "Service Done [Puncture Repair]",
          key: "Service Done [Puncture Repair]",
        },
        {
          label: "Service Done [Battery Charging]",
          key: "Service Done [Battery Charging]",
        },
        {
          label: "Vehicle Running Condition",
          key: "Vehicle Running Condition",
        },
      ],
      content: getTableData(excelWorkList),
    });
  }, [excelWorkList]);
  return {
    trackScrolling,
    fileSelected,
    fileImported,
    processExcel,
    handleFile,
    handleChange,
    showTable,
    tableContent,
    activeShownTotal,
    importDone,
    resultWorkList,
    excelWorkList,
  };
};
